import { Order } from '@app/domain/Order'
import { DeliveryDetails } from '@app/domain/DeliveryDetails'
import { Payment } from '@app/domain/Payment'

export class Sale {
    constructor(
        public id: string,
        public venueId: string,
        public order: Order,
        public payment: Payment | null,
        public deliveryDetails: DeliveryDetails | null,
        public dateCreated: Date,
        public dateUpdated: Date,
        public purpose: SalePurpose = SalePurpose.VoucherPurchase
    ) { }

    remainingLineAmount(lineId: string): number {
        const line = this.order.lineItems.find(item => item.id === lineId)
        return line ? line.unitAmount() * line.quantity - (this.payment?.amountRefundedForLine(lineId) ?? 0) : 0
    }

    isLineRefunded(lineId: string): boolean {
        return (this.payment?.amountRefundedForLine(lineId) ?? 0) > 0 && this.remainingLineAmount(lineId) === 0
    }

    canRefundLine(lineId: string): boolean {
        return this.purpose === SalePurpose.BookingOrder && !!this.payment?.datePaid && this.remainingLineAmount(lineId) > 0
    }

    customerRefundableLineIds(now: Date): string[] {
        if (!this.payment?.canRefundOnline) return []
        return this.order.lineItems.filter(line => this.canRefundLine(line.id)
            && line.customerRefundableUntil !== null && now < line.customerRefundableUntil).map(line => line.id)
    }

    selectedRefundAmount(lineIds: ReadonlySet<string>): number {
        if (!this.payment?.datePaid) {
            return 0
        }
        return this.order.lineItems
            .filter(line => lineIds.has(line.id) && this.canRefundLine(line.id))
            .reduce((total, line) => total + this.remainingLineAmount(line.id), 0)
    }
}

export enum SalePurpose {
    VoucherPurchase = 'VOUCHER_PURCHASE',
    BookingOrder = 'BOOKING_ORDER',
}
